export const MAP_COLORS = {
    plannedRoute: '#1976d2',
    realRoute: '#d32f2f',
    startPoint: '#2e7d32',
    endPoint: '#d32f2f',
    point: '#1976d2',
    operationalPoint: '#ed6c02',
    inferredPosition: '#7e57c2',
    inferenceGpsPosition: '#7e57c2',
    posMark: 'white'
};

export const MAP_SYMBOLS = {
    plannedRoute: '🔵',
    realRoute: '🔴',
    point: '🚏',
    operationalPoint: null,
    startPoint: '🟢',
    endPoint: '🎯',
    vehicle: '🚍',
    inferredPosition: '✦',
    inferenceGpsPosition: '◉',
    posMark: '📌'
};

export const POINT_ICON_CONFIG = {

    point: {
        symbol: MAP_SYMBOLS.point,
        color: MAP_COLORS.point,
        size: 20,
        fontSize: 20,
    },

    operational: {
        symbol: MAP_SYMBOLS.operationalPoint,
        color: MAP_COLORS.operationalPoint,
        size: 10,
        fontSize: 0,
        labelFontSize: 10,
        borderSize: 1
    },

    start: {
        symbol: MAP_SYMBOLS.startPoint,
        color: MAP_COLORS.startPoint,
        size: 24,
        fontSize: 18,
    },

    end: {
        symbol: MAP_SYMBOLS.endPoint,
        color: MAP_COLORS.endPoint,
        size: 24,
        fontSize: 22,
    },

    vehicle: {
        symbol: MAP_SYMBOLS.vehicle,
        color: null,
        size: 30,
        fontSize: 28,
        transparent: true
    },

    inferenceGps: {
        symbol: MAP_SYMBOLS.inferenceGpsPosition,
        color: MAP_COLORS.inferenceGpsPosition,
        size: 22,
        fontSize: 18,
        offsetX: 0,
        offsetY: -1
    },

    inferred: {
        symbol: MAP_SYMBOLS.inferredPosition,
        color: MAP_COLORS.inferredPosition,
        size: 22,
        fontSize: 18,
    },

    posMark: {
        symbol: MAP_SYMBOLS.posMark,
        color: MAP_COLORS.posMark,
        size: 32,
        fontSize: 28
    },

};

export function getPointIconConfigByZoom(zoom) {
    if (zoom >= 18) {
        return {
            size: 20,
            labelFontSize: 20,
            borderSize: 2
        };
    }

    if (zoom >= 17) {
        return {
            size: 18,
            labelFontSize: 18,
            borderSize: 2
        };
    }

    if (zoom >= 16) {
        return {
            size: 17,
            labelFontSize: 17,
            borderSize: 2
        };
    }

    if (zoom >= 15) {
        return {
            size: 16,
            labelFontSize: 16,
            borderSize: 2
        };
    }

    if (zoom >= 14) {
        return {
            size: 12,
            labelFontSize: 12,
            borderSize: 1
        };
    }

    if (zoom >= 13) {
        return {
            size: 10,
            labelFontSize: 10,
            borderSize: 1
        };
    }

    if (zoom >= 12) {
        return {
            size: 6,
            labelFontSize: 6,
            borderSize: 1
        };
    }

    // zoom 11
    return {
        size: 2,
        labelFontSize: 2,
        borderSize: 1
    };
}